module.exports = __webpack_public_path__ + "img/voice.d13a2887.svg";